import { useMemo } from 'react'

import { SupportedSidebar, useSidebar } from 'src/hook/useSidebar'
import { t } from 'src/i18n'

import { PinnedPostsSidebar } from 'src/components'

const usePinPostsSidebar = () => {
  const {
    setSidebarContent,
    isOpenSidebar,
    openSidebar,
    closeSidebar,
    setTitleSidebar,
    sidebarMeta,
    setSidebarMeta
  } = useSidebar()

  const isOpenPinPostsSidebar = useMemo(
    () => isOpenSidebar && sidebarMeta?.name === SupportedSidebar.PIN_POST,
    [sidebarMeta?.name, isOpenSidebar]
  )

  const closePinPostsSidebar = () => {
    closeSidebar()
    setSidebarContent(null)
  }

  const openPinPostsSidebar = () => {
    setTitleSidebar(t('pin_post.highlights.title'))
    setSidebarContent(<PinnedPostsSidebar />)
    setSidebarMeta({ name: SupportedSidebar.PIN_POST })
    openSidebar()
  }

  return {
    openPinPostsSidebar,
    closePinPostsSidebar,
    isOpenPinPostsSidebar
  }
}

export default usePinPostsSidebar
